<template>
  <div class="Vtable">
    <Table
      :data="data"
      :columns="columns"
      :height="height"
      :size="size"
      type="index"
      :loading="loading"
      @on-selection-change="selectionChange"
      @on-row-click=" rowClick">
    </Table>
    <Page
      class="page"
      :total="data.length"
      :page-size-opts="[10,20,50,100]"
      :page-size="params.limit"
      show-total
      show-elevator show-sizer
       @on-change="$emit('pageChange', $event)"
      @on-page-size-change="$emit('pageSizeChange', $event)" />
  </div>
</template>
<script>
  export default {
    data() {
      return {
        pageSize: 20,
        tableData: [],
        loading: false
      }
    },
    props: {
      //请求接口
      getTableList: {type: Function},
      //参数  默认返回分页和条数
      params: {
        type: [Object,String,Number],
        default: () => {
          return { page: 1, limit: 15 };
        }
      },
      // 表格配置项
      columns: {
        type: Array,
        default: () => {
          return []
        }
      },
      data: Array,
      // 表格高度
      height: { 
        type: String | Number,
        default: 500
      },
      size: {
        type: String,
        default: 'default'
      },
      
    },
    created() {
    },
    methods: {
      // 请求接口方法
      init (params) {
        // this.loading = true
        // this.DataApi.getTableList().then(res => {
        //   this.tableData = res.data || []
        //   // 如果有分页
        //   if(this.paging){
        //     this.tableCount = res.count || 0;
        //     this.params.page = res.curr || 0;
        //   }
        // })
        // .finally(() => {
        //   this.loading = false; 
        // });
      },
      // 重新请求 //如果需要重新请求使用$refs 调用这个方法
      reload() {
        // 如果有分页
        if(this.paging){
          this.params.page = 1;
        }
        // api动态加载完 开始重新请求数据
        this.$nextTick(()=>{
          this.init(this.params);
        })
      },

      // 点击表格当前行
      rowClick(row, event, column) {
        this.$emit('row-click', row, event, column)
      },
      // 表格翻页的回调
      // pageChange(current) {
      //   if(current) {
      //     this.params.page = current;
      //   }
      //   this.init(this.params);
      // },
      // //选择每页几条的回调
      // limitChange(current){
      //   if(current) {
      //     this.params.limit = current;
      //   }
      //   // this.init(this.params);
      // },
      // 多选
      selectionChange(val) {
        this.$emit('selection-change', val)
      },
      // 单选
      currentChange(currentRow, oldCurrentRow) {
        this.$emit('current-change', currentRow, oldCurrentRow)
      },
    }
  }
</script>
<style >
  .page {
    margin-top: 10px;
  }
 .Vtable a{
    color: rgb(37, 104, 228) !important;
  }
</style>